<template>
	<div>

    <header class="jumbo-page-header">
      <h1
        class="locator-title"
        id="aria-label_faq"
        tabindex="-1"
        style="outline: none"
      >
        Frequently Asked Questions
      </h1>
      <p :style="{'font-size': 'small'}" class="locator-subtitle ml-4 pb-2">
        If you still have unanswered questions feel free to send us a <router-link to="/contact">message.</router-link>
      </p>
    </header>

		<main role="main">
			<div class="container px-3">
				<div>
					<p class="question">What is ChooseMesa?</p>
					<p class="answer">ChooseMesa is an application to help parents choose the right school for their children. There are 80 schools in the Mesa Public School system that offer a variety of features and programs. Information about the schools and their respective programs are available throughout the application. If more detailed information is needed please visit the main district <a href="http://www.mpsaz.org" target="_blank">website</a>. This application will be updated overtime to provide parents a better experience. If you see room for improvement please send us a message through our <router-link to="/contact">contact form</router-link></p>
				</div>
				<hr>
				<div>
					<p class="question">How does enrollment work?</p>
					<p class="answer">Enrollment and re-enrollment can both be done online. Head over to the parent portal to get started. If you'd like to fill out a paper application you will need to go to the specific school's location. You can register your child at anytime throughout the year, but enrollment for the next school year will open up in February of each year</p>
				</div>
				<hr>
				<div>
					<p class="question">Can my child take the bus?</p>
					<p class="answer">Students may take the bus only if they are attending their homeschools. To find your homeschools please use the address filter on the schools page. Due to funding and overcrowding issues if you would like your student to attend a school other than their homeschool, you will be responsible for transportation.</p>
				</div>
				<hr>
				<div>
					<p class="question">What are kindergarten registration requirements?</p>
					<p class="answer">Your child must be 5 years old by August 31st. <a href="http://www.mpsaz.org/tl/kindergarten" target="_blank">Learn more about early learner options</a></p>
				</div>
			</div>
		</main>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			document.querySelector('#aria-label_faq').focus()
		}
	}
</script>

<style lang="scss" scoped>
  .question {
  	font-size: 1.5rem;
  	font-family: 'Montserrat', sans-serif;
  	margin-bottom: 15px;
  }
  .answer {
  	font-size: 1rem;
  	font-family: 'Roboto', sans-serif;
  }

  @media screen and (min-width: 1024px) {
		.question {
			font-size: 1.75rem;
		}
		.answer {
			font-size: 1.25rem;
		}
	}
</style>
